import { handleError } from "core/utils/HandleError";
import { handleResponse } from "core/utils/HandleResponse";
import { AuthHttpClient } from "core/utils/HttpClient";

export function getParticipantInfo(tournamnetId: string) {
  return AuthHttpClient.get(`/admin/tournament/teams/${tournamnetId}`)
    .then(handleResponse)
    .catch(handleError);
}

export function updateTeamData(tournamnetId: string, data: any) {
  return AuthHttpClient.patch(
    `/admin/participant-info/update/${tournamnetId}`,
    data
  )
    .then(handleResponse)
    .catch(handleError);
}

export function updateTeamCheckIn(data: any) {
  return AuthHttpClient.put(`/admin/tournament/vs-mode/team/check-in`, data)
    .then(handleResponse)
    .catch(handleError);
}

export function getBracektSettings(tournamentId: string, params: any) {
  return AuthHttpClient.get(`/admin/tournament/vs-mode/settings/${tournamentId}`, { params })
    .then(handleResponse)
    .catch(handleError);
}

export function createBracketPlayoff(data: any) {
  return AuthHttpClient.post(`/admin/tournament/vs-mode/playoff`, data)
    .then(handleResponse)
    .catch(handleError);
}
